import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {Image} from 'app/blocks/model/image.model';

export interface ICatalogueEntity extends IBaseEntity {
    id?: number;
    name?: string;
    customFieldGroupIds?: number[];
    employeeGroupIds?: number[];
    presentationIds?: number[];
    resourceGroupIds?: number[];
    fieldFilterIds?: number[];
    coverImage?: Image;
    categories?: ICatalogueCategory[];
    attributeWhitelistId?: number;
    versions: ICatalogueVersion[];
}

export interface ICatalogueCategory {
    id: number;
    name: string;
    parentId: number;
    sequence?: number;
    contentFilters?: ICatalogueContentFilter[];
    selectedClasses?: number[];
    selectedBrands?: number[];
}
export interface ICatalogueAttributeFilter {
    id?: number;
    categoryId?: number;
    productAttributeTypeId?: number;
    attributeFilters?: string[];
}

export interface ICatalogueContentFilter {
    id?: number;
    categoryId?: number;
    attributeFilter?: string;
    attributeValue?: string;
    comparisonOperator?: string;
}

export interface ICatalogueVersion {
    id: number;
    name: string;
    publicationType: string;
    publishDate: string;
}

export class CatalogueEntity extends BaseEntity implements ICatalogueEntity {
    public id?: number;
    public name?: string;
    public customFieldGroupIds?: number[];
    public employeeGroupIds?: number[];
    public presentationIds?: number[];
    public resourceGroupIds?: number[];
    public categories?: ICatalogueCategory[];
    public coverImage?: Image;
    public fieldFilterIds?: number[];
    public attributeWhitelistId?: number;
    public versions: ICatalogueVersion[];

    constructor(catalogue?: any) {
        super();
        if (catalogue) {
            this.id = catalogue.id;
            this.name = catalogue.name;
            this.customFieldGroupIds = catalogue.customFieldGroupIds ?? [];
            this.employeeGroupIds = catalogue.employeeGroupIds ?? [];
            this.presentationIds = catalogue.presentationIds ?? [];
            this.resourceGroupIds = catalogue.resourceGroupIds ?? [];
            this.categories = catalogue.categories ?? [];
            this.fieldFilterIds = catalogue.fieldFilterIds ?? [];
            this.coverImage = catalogue.coverImage;
            this.attributeWhitelistId = catalogue.attributeWhitelistId ?? null;
            this.versions = catalogue.versions ?? [];
        }
    }

    clone(): IBaseEntity {
        return new CatalogueEntity(this);
    }

    get discriminator(): any {
        return this.id + ' - ' + this.name;
    }
}
